import PropTypes from 'prop-types';
import React from 'react'
import RadioGroup from 'react-radio-group'
import { findIndex, filter } from 'underscore'

import { Add as InterestBox } from './components'
import { toggleInterests } from '~/actions/interests'


export default class extends React.Component {
    static propTypes = {
		dispatch: PropTypes.func,
		message: PropTypes.string,
		interests: PropTypes.array.isRequired,
		userInterests: PropTypes.array.isRequired,
		changeInterest: PropTypes.func
	};

    state = {
        displayedInterests: [],
        reservedInterests: []
    };

    componentWillMount() {
		var userInterestIDs = this.props.userInterests.map(function(a) {return a.ID;}),
			displayedInterests = this.props.interests.filter(function(i) { return userInterestIDs.indexOf(i.ID) === -1 });
 		this.setState({
			displayedInterests: displayedInterests.slice(0,5),
			reservedInterests: displayedInterests.slice(6)
 		})

	}

    addInterest = (ID) => {

		var newInterests = this.state.displayedInterests,
			indexOfThis = findIndex(newInterests, {ID: ID});
		if( indexOfThis < 0 ) return;

		newInterests.splice(indexOfThis,1)

		let newReservedInterests = this.state.reservedInterests,
			newDisplayedInterests = newInterests;

		if( this.state.reservedInterests.length > 0 ) {
			newDisplayedInterests = newDisplayedInterests.concat( this.state.reservedInterests[0] )
			newReservedInterests.splice(0,1)
		}

		this.setState({
			displayedInterests: newDisplayedInterests,
			reservedInterests: newReservedInterests
		})

		this.props.dispatch( toggleInterests([ ID ]) )

		if(!!this.props.changeInterest) this.props.changeInterest(newInterests)

	};

    render() {

		let editable = !!this.props.dispatch,
			interestLoop = filter(this.state.displayedInterests, {hidden: false});

		return (

			<div>
				{ (!!this.props.message || !interestLoop.length) && 
					<p className={"text-center text-mid-gray "+(interestLoop.length > 0 ? 'mbot40' : '')}>{
						interestLoop.length > 0 
							? this.props.message
							: "You've already added all of the recommended interests!"
					}</p>
				}
				<div className="interestBoxGrid">
					{ interestLoop.map(interest => {
						return <InterestBox 
									{...interest} 
									editable={editable}
									key={interest.ID}
									clickAction={this.addInterest} />
			        }) }
		        </div>
			</div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/components/Interests/Add.js